import { TaskDto } from './task.dto';

export class GetTaskResponseDto {
    task: TaskDto;

    constructor(task: TaskDto) {
        this.task = task;
    }
}
